<script setup lang="ts">
import MapMarkerHouseIcon from "@/areas/MapMarkerHouseIcon.vue";
import type { CanvassHouse } from "@/canvasses/types";
import { useCanvassHouseColor } from "./canvassHouseColor";

const { canvassHouse } = defineProps<{
  canvassHouse: CanvassHouse;
}>();

const color = useCanvassHouseColor(() => canvassHouse);
</script>

<template>
  <MapMarkerHouseIcon :color />
</template>
